import { createReducer } from '@reduxjs/toolkit';
import * as AM_COMMON from '@innovyze/lib-am-common/Reducers';
import {
  listCostTablesAction,
  listCostTableActionResolved,
  listCostTablesActionRejected,
  getCostTableDetailsAction,
  getCostTableDetailsActionResolved,
  getCostTableDetailsActionRejected,
  invalidateCostTablesOverview,
  saveCostTableListGridState,
} from '@Actions/costTables.actions';
import { CostTablesStoreState } from '@Types/costTable.types';

export const initState: CostTablesStoreState = {
  costTablesOverview: {
    ...AM_COMMON.paginationInitialState,
    totalCount: 0,
    successful: null,
  },
  costTableListGridState: null,
  costTableDetails: {
    isLoading: false,
    isWaiting: false,
    status: null,
    successful: null,
    costTable: null,
    costTableData: [],
  },
};

export const reducer = createReducer(initState, builder => {
  builder
    .addCase(listCostTablesAction, state => {
      state.costTablesOverview = {
        ...AM_COMMON.updateIsLoading(AM_COMMON.paginationInitialState, true),
        totalCount: state.costTablesOverview.totalCount,
        successful: null,
      };
    })
    .addCase(listCostTableActionResolved, (state, action) => {
      const resolvedState = AM_COMMON.updateResolved(
        state.costTablesOverview,
        action.payload
      );
      state.costTablesOverview = {
        ...resolvedState,
        totalCount: action.payload.totalCount || 0,
        successful: true,
      };
    })
    .addCase(listCostTablesActionRejected, (state, action) => {
      const rejectedState = AM_COMMON.updateRejected(
        state.costTablesOverview,
        action.payload
      );
      state.costTablesOverview = {
        ...rejectedState,
        totalCount: state.costTablesOverview.totalCount,
        successful: false,
      };
    })
    .addCase(getCostTableDetailsAction, state => {
      if (state.costTableDetails) {
        state.costTableDetails.isLoading = true;
        state.costTableDetails.isWaiting = false;
        state.costTableDetails.status = null;
        state.costTableDetails.successful = null;
      }
    })
    .addCase(getCostTableDetailsActionResolved, (state, action) => {
      if (state.costTableDetails) {
        const data = action.payload.data as any;
        state.costTableDetails.isLoading = false;
        state.costTableDetails.isWaiting = false;
        state.costTableDetails.status = 'success';
        state.costTableDetails.successful = true;
        state.costTableDetails.costTable = {
          id: data.cost_table.id,
          name: data.cost_table.name,
          assetGroupSet: data.cost_table.asset_group_set,
          costPer: data.cost_table.cost_per,
          lastUpdated: data.cost_table.last_updated,
          latestCostTableDataId: data.cost_table.latest_cost_table_data_id,
        };
        state.costTableDetails.costTableData = data.cost_table_data.map(
          (item: any) => ({
            id: item.id,
            assetGroupSet: item.asset_group_set,
            description: item.description,
            assetCount: item.asset_count,
            unitCost: item.unit_cost,
          })
        );
      }
    })
    .addCase(invalidateCostTablesOverview, state => {
      state.costTablesOverview.successful = null;
    })
    .addCase(saveCostTableListGridState, (state, action) => {
      state.costTableListGridState = action.payload;
    })
    .addCase(getCostTableDetailsActionRejected, (state, action) => {
      if (state.costTableDetails) {
        state.costTableDetails.isLoading = false;
        state.costTableDetails.isWaiting = false;
        state.costTableDetails.status = action.payload.text || 'error';
        state.costTableDetails.successful = false;
        state.costTableDetails.costTable = null;
        state.costTableDetails.costTableData = [];
      }
    });
});

export default reducer;
